import { Grid } from "antd";
import { APP_LOGO, PHONE_RING } from "assets";
import { useScrollTop } from "global/hooks";
import { navLinks } from "layouts/default/data";
import { NavLink } from "react-router-dom";
import { ReactSVG } from "react-svg";
import TopBar from "../infoTopBar";
import Sidebar from "../sidebar";

const { useBreakpoint } = Grid;

const Header = () => {
  const screens = useBreakpoint();
  const atTop = useScrollTop(null, 50);

  return (
    <>
      {screens.md && <TopBar isOpen />}
      <HeaderMain  atTop={atTop} screens={screens} />
    </>
  );
};

export default Header;

const HeaderMain = ({ screens, atTop }) => (
  <header className={atTop ? "" : "shadow"}>
    <div className="header-main">
      <div className="container header-main-inner">
        <img src={APP_LOGO} alt="app-logo" />
        <div className="header-main-inner-right">
          {screens.md ? (
            <>
              <div className="navlinks-wrapper">
                {navLinks.map((navLink, index) => (
                  <NavLink to={navLink.to} key={index}>
                    {navLink.title}
                  </NavLink>
                ))}
              </div>
              <div className="contact-info">
                <ReactSVG src={PHONE_RING} />
                <div className="contact-info-right">
                  <span className="text-black-subtle">Urgent Call</span>
                  <a
                    className="text-black font-w-semi-bold"
                    href="tel:+447921841924"
                  >
                    +447921841924
                  </a>
                </div>
              </div>
            </>
          ) : (
            <Sidebar />
          )}
        </div>
      </div>
    </div>
  </header>
);
